interface KyrgyzstanBookingParams {
  start_date?: string
  end_date?: string
}

export const hasCompleteKyrgyzstanBookingParams = (
  detailSearchParams?: KyrgyzstanBookingParams | null,
): boolean =>
  Boolean(detailSearchParams?.start_date && detailSearchParams.end_date)
